export function assertDefined<T>(
  value: T | undefined,
  message = 'Value is undefined'
): asserts value is T {
  if (value === undefined) {
    throw new Error(message)
  }
}
